const { default: AspApi } = require('api/ApiConfig');

export const createWABA = async (payload) => {
  const res = await AspApi.post(`api/v1/svc/whatsapp/waba/create`, payload);
  return res;
};

export const retryCreateWABA = async (payload) => {
  const res = await AspApi.post(`api/v1/svc/whatsapp/waba/retry`, payload);
  return res;
};
